/*
 * @Descripttion:
 * @version:
 * @Author: yanghui
 * @Date: 2021-10-20 15:40:46
 * @LastEditors: yanghui
 * @LastEditTime: 2021-10-29 14:39:47
 */
/**
 * Created by lk on 17/6/4.
 */
 import axios from "../../utils/axios";

 // 获取列表
 export function getAskerListApi(data) {
     return axios({
         url: "/hfAskerManage/getAskerList",
         method: "post",
         data: data
     });
 }


  // 商品询价详情
  export function getAskerDetailsApi(query) {
    return axios({
        url: "/hfAskerManage/getAskerDetails",
        method: "get",
        params: query
    });
}

//商品回复询价
export function replyMailApi(query) {
  return axios({
      url: "/hfAskerManage/replyMail",
      method: "post",
      params: query
  });
}


 // 获取角色列表
 export function authAdminRoleList(query) {
     return axios({
         url: "/admin/roleList",
         method: "get",
         params: query
     });
 }

 // 保存
 export function authAdminSave(data, formName, method = "post") {
     let url = formName === "add" ? "/admin/save" : "/admin/edit";
     return axios({
         url: url,
         method: method,
         data: data
     });
 }

 // 删除管理员
 export function authAdminDelete(data) {
     return axios({
         url: "/admin/delete",
         method: "post",
         data: data
     });
 }
